<template>
  <div class="download-page-list">
    <strong class="download-page-list__title">{{ downloadPageListTitle }}</strong>
    <div v-for="(item, index) in downloadPageListWithDownloadOverview" :key="index">
      <b class="download-page-list__subtitle" v-if="itemSubtitleNeeded">
        {{ item.external.title }}
      </b>
      <div class="download-page-list__inner">
        <download-page-item
          v-for="downloadPageItem in item.nodes"
          :key="downloadPageItem.id"
          :title="setProperFieldExternalFirst(downloadPageItem, 'title')"
          :img="setProperFieldExternalFirst(downloadPageItem, 'fileName')"
          :resources="downloadPageItem.resources"
          :link="`${mainCategories.downloads}/${item.nodeId}/${downloadPageItem.nodeId}/`"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { setProperFieldExternalFirst } from '@/utils/fieldGetters';

  interface DownloadPageNode {
    id: string;
    nodeId: string;
    productBlockType: string;
    resources?: any[];
    external?: {
      title?: string;
      fileName?: string;
    };
    title?: string;
    fileName?: string;
  }

  interface DownloadPageItem {
    nodeId: string;
    nodes: DownloadPageNode[];
    external: {
      title: string;
    };
  }

  const props = defineProps<{
    downloadPageList?: DownloadPageItem[];
    downloadPageListTitle?: string;
    itemSubtitleNeeded?: boolean;
  }>();

  const mainStore = useMainStore();
  const mainCategories = computed(() => mainStore.mainCategories);

  const downloadPageListWithDownloadOverview = computed(() => {
    const newArr: DownloadPageItem[] = [];
    if (!props.downloadPageList) return newArr;

    for (let index = 0; index < props.downloadPageList.length; index++) {
      const item = { ...props.downloadPageList[index] };
      const downloadPageItems = item.nodes.filter((i) => i.productBlockType == 'DownloadOverview');
      item.nodes = downloadPageItems;
      newArr.push(item);
    }
    return newArr;
  });
</script>
